// "What actually happened?" — the integrator's recent syncs from
// GET /integrator/history, with RETRY on errored rows. A halted stop-on-error queue
// reads directly off this list: the first errored row of the job is the one blocking
// everything behind it.
class IntegratorHistoryViewController extends MUIViewController
{
    static newInstance(): IntegratorHistoryViewController {
        let vc = new IntegratorHistoryViewController("integrator-history-view");
        vc.initWithResource("layout/setup/IntegratorHistoryView.html");
        return vc;
    }

    private backButton: MUIButton = null;
    private refreshButton: MUIButton = null;
    private titleLabel: MUILabel = null;
    private tableView: UITableView = null;

    private _integrator: Integrator = null;
    set integrator(item: Integrator) {
        this._integrator = item;
        this.reload();
    }

    private _syncs: any[] = [];

    viewDidLoad() {
        super.viewDidLoad();

        this.backButton = MUIOutlet(this, "back-btn", "MUIButton");
        this.backButton.setAction(this, function() {
            this.navigationController.popViewController(true);
        });

        this.refreshButton = MUIOutlet(this, "refresh-btn", "MUIButton");
        this.refreshButton.setAction(this, function(this:IntegratorHistoryViewController) {
            this.reload();
        });

        this.titleLabel = MUIOutlet(this, "title-lbl", "MUILabel");

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;

        this.reload();
    }

    private reload() {
        if (this.viewIsLoaded == false || this._integrator == null) return;
        this.titleLabel.text = this._integrator.name;

        let ws = MUIWebApplication.sharedInstance().delegate.webService;
        ws.integratorHistory(this._integrator, (syncs: any[], error: any) => {
            this._syncs = syncs || [];
            this.tableView.reloadData();
        });
    }

    numberOfSections(tableview) { return 1; }
    numberOfRowsInSection(tableview, section) { return this._syncs.length; }

    cellAtIndexPath(tableview, indexPath: MIOIndexPath) {
        let cell = tableview.dequeueReusableCellWithIdentifier("IntegratorHistoryCell") as IntegratorHistoryCell;
        cell.item = this._syncs[indexPath.row];
        cell.onRetry = (sync: any) => this.retry(sync);
        return cell;
    }

    private retry(sync: any) {
        let ws = MUIWebApplication.sharedInstance().delegate.webService;
        ws.retryIntegratorSync(sync["identifier"], (json: any, error: any) => {
            if (error != null || json == null || json["ok"] != true) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("RETRY", "RETRY"), error ?? (json != null ? json["error"] : null) ?? MIOLocalizeString("NO_RESPONSE", "NO RESPONSE"));
                return;
            }
            AppHelper.showInfoMessage(this, MIOLocalizeString("RETRY", "RETRY"), (json["concept"] ?? "") + " " + MIOLocalizeString("REQUEUED", "requeued"));
            this.reload();
        });
    }
}
